
import { useState } from 'react'
import AddAlarmIcon from '@mui/icons-material/AddAlarm';
import Y from './ListDam.module.css'
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import G from '../images/userr.png'
import D from './Settings.module.css'
import S from './AllFarmsAdmin.module.css'
import LoadingCop from '../Components/Loading';
import { Link } from 'react-router-dom';
import InfoIcon from '@mui/icons-material/Info';
import { useGlobalContext } from '../Components/Context';
import EditAdmin from '../Components/editAdminModal';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import F from './ListDam.module.css';
import ReportIcon from '@mui/icons-material/Report';

import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import TimeModal from '../Components/dateModal';
import apiService from '../api/ApiService';
import AddUser from '../Components/CreateNewUSERMOdal';
import UserList from '../Components/cardThemes/UserList';
import EditUserInfo from '../Components/editUserInfo';
import { setUsers } from '../redux/slices/adminSlice';
import { ChangeCircle, ChangeHistory, Key, MobileFriendly, Person3Rounded, SplitscreenOutlined, TitleRounded } from '@mui/icons-material';
import Title from '@mui/icons-material/Title';
import EmptyReturn from '../Components/EmptyReturn';
import { Switch } from '@mui/material';


const Settings=()=>{
  const [Value,setValue]=useState(0)
  const [iindex,setIindex]=useState()
  const [types,setTypes]=useState(['کاربر','ادمین'])
  const [currentName,setCurrentName]=useState('')
    const {openD,opens,isOpenModal,openModalls,isOpenModal2,openModalls2,closeModalls2}=useGlobalContext();
    const dispatch=useDispatch()
    const {currentAdmin,currentTheme,currentUsers}=useSelector(state=>state.p.admin)
    

    const toggleUser=async(id,index)=>{
      const res=await apiService.toggleUser(id);
      const editedList = [
        ...currentUsers[0].slice(0,index),
        res.data,
        ...currentUsers[0].slice(index+1)
      ];
      dispatch(setUsers([editedList,currentUsers[1]]))

    }

    const getAllUsers=async()=>{
      const data=JSON.stringify({
        "skip": -1,
        "take": -1,
        "fromDate": null,
        "toDate": null,
        "farmId": currentAdmin.id,
        "isActive": null
      })
      const res=await apiService.getUsers(data);
      const res2=await apiService.getAdmins(data);
      dispatch(setUsers([res.data.data,res2.data.data]))

    }
    
    useEffect(()=>{
      getAllUsers()
    },[])
return <>
<div className={D.Settingcontainer}>
<div style={{display:'flex',justifyContent:'space-between',alignItems:'center',width:'100%'}}>
      <div className={F.AllAnimalssTitleLICon}>
        <img className={F.AllAnimalssIconimgLITit} style={{width:'70px',height:'70px'}} src={G}/>
        <h2> کاربران</h2>
        </div>
        <div style={{display:'flex',gap:'20px'}}>
        <div onClick={openD} data-title='افزودن کاربر جدید' className={`${F.CreateNewFarmBtn}`}>
                <AddCircleOutlineIcon sx={{fontSize: { xs: 26, sm: 30, md: 30, lg:30} }}/>
        </div>
        {/* <div className={`${F.CreateNewFarmBtn}`} onClick={openModallTime}>
                 <AddAlarmIcon/>
                    
                           
                              
                       

                </div> */}
           
        </div>
      </div>
      <hr/>
      <div className={Y.TabForAllAnnimLICon}>
          <div className={Y.TabForAllAnnimbtnLICon}>
            {types&&types.map((item,index)=>{
              return <div key={index} className={`${Y.jobbtnLItab} ${index === Value && Y.ActiveLITab}`} onClick={()=>setValue(index)} >{item}</div>
              

            })}
          </div>
          
          {!currentTheme&&<div className={Y.AnimContentLI} data-aos='fade'>
          {currentUsers[Value]?.length?<table>
              <thead>
              <tr>
                  <th>
                  <div className='LogoFormT'><div><span>
                <SplitscreenOutlined/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <TitleRounded/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <Title/>
                </span>
                    </div></div> 
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <Person3Rounded/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <MobileFriendly/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <ReportIcon/>
                </span>
                    </div></div>
                  </th>
                  
                  <th>
                  <div className='LogoFormT'><div><span>
                <ChangeHistory/>
                </span>
                    </div></div>
                  </th>
                  <th>
                  <div className='LogoFormT'><div><span>
                <Key/>
                </span>
                    </div></div>
                  </th>
                </tr>
                <tr>
                  <th>
                    ردیف
                  </th>
                  <th>
                     نام
                  </th>
                  <th>
                    موضوع 
                  </th>
                  <th>
                     نقش
                  </th>
                  <th>
                     شماره همراه
                  </th>
                  <th>
                    فعال / غیر فعال
                  </th>
                  
                  <th>
                    تغییر  مشخصات
                  </th>
                  <th>
                    تغییر رمز عبور
                  </th>
                </tr>
              </thead>
              <tbody>
                {
                  currentUsers?.length&&currentUsers[Value]?.map((item,index)=>{
                  
                    return <tr key={index}>
                    <td>
                      {index+1}
                    </td>
                    <td>
                      {item.username}
                    </td>
                    <td>
                      {item.title}
  
                    </td>
                    <td>
                      {item.role}
  
                    </td>
                    <td>
                      {item.phoneNumber}
  
                    </td>
                    <td >
                <Switch color="success" checked={item?.isActive} onChange={()=>toggleUser(item.id,index)} />

                    </td>
                    
                    
                   
            
                    <td className={Y.DetIc}>
                      <Link onClick={()=>{setIindex(index);openModalls2();setCurrentName(item)}}>
                      <InfoIcon/>
                      
                      </Link>
                    </td>
                    <td className={Y.DetIc}>
                      <Link onClick={()=>{openModalls();setCurrentName(item)}}>
                      <InfoIcon/>
                      
                      </Link>
                    </td>
                  </tr>
                  
                  })
                }
                
                
                
                
                

              </tbody>
            </table>:<EmptyReturn/>}
          </div>}
          {currentTheme&&<UserList Value={Value}/>}
        </div>
 

   
          
        {!currentTheme&&isOpenModal2&&<EditUserInfo iindex={iindex} data={currentName}/>}
        {!currentTheme&&isOpenModal&&<EditAdmin namee={currentName}/>}
            {opens&&<AddUser/>}
</div>

</>
}
export default Settings